// Caché local en IndexedDB (idb-keyval): la última lista de tarjetas, perfil, personas,
// cronómetro abierto, registros propios recientes, detalle de tarjetas abiertas (con sus
// registros) y la cola offline. Permite usar la app sin red con lo último que se vio.

import { createStore, del, get, set, clear } from 'idb-keyval';
import type { QueuedAction, QueueStorage } from './queue.ts';
import type {
  CardDetail,
  CardListItem,
  NotionUser,
  PersonSummary,
  Profile,
  SyncStatus,
  TimeEntry,
  WorkLog,
} from './types.ts';

const store = createStore('tablero', 'cache');

export interface CachedState {
  userId: string;
  profile: Profile | null;
  cards: CardListItem[];
  notionUsers: NotionUser[];
  people: PersonSummary[];
  openEntry: TimeEntry | null;
  /** Falta en cachés de v1. */
  myLogs?: WorkLog[];
  syncStatus: SyncStatus | null;
  savedAt: string;
}

export interface CachedCard {
  card: CardDetail;
  /** Falta en cachés de v1 (guardaban `entries`). */
  logs?: WorkLog[];
}

export const cache = {
  async loadState(): Promise<CachedState | undefined> {
    return get<CachedState>('state', store);
  },
  async saveState(state: CachedState): Promise<void> {
    await set('state', state, store);
  },
  async loadCard(id: string): Promise<CachedCard | undefined> {
    return get(`card:${id}`, store);
  },
  async saveCard(id: string, value: CachedCard): Promise<void> {
    await set(`card:${id}`, value, store);
  },
  async forgetCard(id: string): Promise<void> {
    await del(`card:${id}`, store);
  },
  async clearAll(): Promise<void> {
    await clear(store);
  },
};

export const queueStorage: QueueStorage = {
  async load() {
    return (await get<QueuedAction[]>('queue', store)) ?? [];
  },
  async save(actions) {
    await set('queue', actions, store);
  },
};
